module.exports = __webpack_public_path__ + "static/fleet-49-seat-coach-sm-2b93c81e08030d27788d7f1ae7ac0210.jpg";